import React from 'react';
import { Route } from 'react-router-dom';
import AuthenticatedRoute from 'app/routes/AuthenticatedRoute';
import AccountRequiredRoute from 'app/routes/AccountRequiredRoute';
import UsersPageRoute from '../users/UsersPageRoute';
import PrintCheckedOutPageRoute from './PrintCheckedOutPageRoute';
import PrintHoldsPageRoute from './PrintHoldsPageRoute';
import PrintInterlibraryLoansPageRoute from './PrintInterlibraryLoansPageRoute';
import PrintRecentlyReturnedPageRoute from './PrintRecentlyReturnedPageRoute';
import PrintSearchPageRoute from './PrintSearchPageRoute';
import PrintShelfPageRoute from './PrintShelfPageRoute';

const basePath = '/v2/print';

export default (
  <>
    <Route path={`${basePath}/holds/:status?`}>
      <AuthenticatedRoute>
        <AccountRequiredRoute>
          <PrintCheckedOutPageRoute />
        </AccountRequiredRoute>
      </AuthenticatedRoute>
    </Route>
    <Route path={`${basePath}/checkedout/:status?`}>
      <AuthenticatedRoute>
        <AccountRequiredRoute>
          <PrintHoldsPageRoute />
        </AccountRequiredRoute>
      </AuthenticatedRoute>
    </Route>
    <Route path={`${basePath}/interlibraryloans/:status?`}>
      <AuthenticatedRoute>
        <AccountRequiredRoute>
          <PrintInterlibraryLoansPageRoute />
        </AccountRequiredRoute>
      </AuthenticatedRoute>
    </Route>
    <Route path={`${basePath}/recentlyreturned`}>
      <AuthenticatedRoute>
        <AccountRequiredRoute>
          <PrintRecentlyReturnedPageRoute />
        </AccountRequiredRoute>
      </AuthenticatedRoute>
    </Route>
    <Route path={`${basePath}/search`}>
      <PrintSearchPageRoute />
    </Route>
    <Route path={`${basePath}/users/:userId/shelves/:shelfName`}>
      <UsersPageRoute>
        <PrintShelfPageRoute />
      </UsersPageRoute>
    </Route>
  </>
);
